/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { toast } from "react-toastify";

const Breadcrumb = ({ page, setPage, componentPage, formData }) => {
  //** Gestion des changements de pages via la barre de navigation en haut du formulaire(breadcrumb) */
  const handlePageChange = (page) => {
    let error = false;
    document.querySelectorAll("#myForm").forEach((input) => {
      const isValidInput = input.checkValidity();
      if (!isValidInput || !formData.MandataireOuiNon) {
        error = true;
        toast.error(
          "Vous devez d'abord compléter cette page ou cliquer sur le bouton retour"
        );
      }
      if (!error) {
        setPage(page);
      }
    });
  };

  const renderPageTitles = () => {
    const pageTitles = [
      "1. Informations sur le demandeur",
      "2. Informations sur le projet",
      "3. Informations sur le local",
      "Validation",
    ];
    return pageTitles.map((pageTitle, index) => (
      <li
        key={index}
        className={
          page === index + 1 ? "active" : page > index + 1 ? "active" : null
        }
      >
        {page === 4 ? (
          <a href="#" data-bs-toggle="modal" data-bs-target="#modalResetFiles">
            {pageTitle}
          </a>
        ) : (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(index + 1);
            }}
          >
            {pageTitle}
          </a>
        )}
      </li>
    ));
  };

  return (
    <>
      <div
        className={
          page > 0 && page <= 4
            ? "w-100 d-flex justify-content-end d-block d-md-none"
            : "d-none"
        }
      >
        <p className="breadcrumb-small p-2">
          Etape {page} sur {componentPage.length - 2}
        </p>
      </div>
      <div
        className={page > 0 && page <= 4 ? "d-none d-lg-block pb-4" : "d-none"}
      >
        <ul className="breadcrumb">{renderPageTitles()}</ul>
      </div>
    </>
  );
};

export default Breadcrumb;
